import { type RootState } from '@verantos-dev/core-annotation-tool';

export const selectProjectsListPage = (state: RootState) =>
  state.annotatorProject?.projectsListPage ?? 0;
export const selectProjectsListPageSize = (state: RootState) =>
  state.annotatorProject?.projectsListPageSize ?? 25;
